<template>
  <div class="footer-navigation">
    <grid-container>
      <ul class="footer-navigation__list">
        <grid-row>
          <li class="footer-navigation__item">
            <transition name="fade-up">
              <button
                v-if="prev"
                class="footer-navigation__link"
                @click.prevent="handlePrev"
              >
                <span class="footer-navigation__link-arrow">– </span><br>
                {{ prev }}
              </button>
            </transition>
          </li>
          <li class="footer-navigation__item">
            <transition name="fade-up">
              <button
                v-if="next"
                class="footer-navigation__link"
                @click.prevent="handleNext"
              >
                <span class="footer-navigation__link-arrow">+ </span><br>
                {{ next }}
              </button>
            </transition>
          </li>
        </grid-row>
      </ul>
    </grid-container>
  </div>
</template>

<script>
export default {
  props: {
    next: {
      type: String,
      default: ''
    },
    prev: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleNext () {
      if (this.next) {
        this.$emit('next')
      }
    },
    handlePrev () {
      if (this.prev) {
        this.$emit('prev')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer-navigation {
    @include vertical-space((bottom: 1, top: 1), padding);

    @include media-up(md) {
      @include vertical-space((bottom: 1, top: 6), padding);
    }

    &__list {
      @include reset-list;
    }

    &__item {
      @include grid-column((xs: 12, md: 6, lg: 4));

      &:first-child {
        @include grid-offset((lg: 3));
      }

      &:last-child {
        @include hide-down(md);
      }
    }

    &__link {
      @include reset-button;
      @include text(big, bold);
      text-align: left;

      display: inline-block;
      outline: none;

      &-arrow {
        display: inline-block;
        transform: rotate(0deg);
        transition: transform $base-transition;
      }
    }

    &__link:hover &__link-arrow,
    &__link:focus &__link-arrow {
      transform: rotate(180deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue